import getBreakpoint from '../shared/helpers/getBreakpoints';
import InitChunks from '../modules/InitChunks/InitChunks';

/**
 * Abstract Class Page
 */
export default class Page {
  constructor() {
    if (this.constructor === Page) {
      throw new Error("Abstract classes can't be instantiated.");
    }

    // Load chunks in page
    new InitChunks();

    // Cookie
    Page.cookieMediaQuery();
  }

  /*
   * Set Media Query in Cookie
   * */
  private static cookieMediaQuery(): void {
    const key = 'media_query';
    const matchCookie = document.cookie.match(
      new RegExp(`(^| )${key}=([^;]+)`)
    );

    if (!matchCookie) {
      const date = new Date();
      const days = 1;
      const value = getBreakpoint;

      // Add Cookie 'first_time_loyalty'
      date.setTime(+date + days * 86400000); // 24 * 60 * 60 * 1000
      window.document.cookie = `${key}=${value}; expires=${date.toUTCString()}; path=/`;
    }
  }
}
